module.exports = __webpack_public_path__ + "static/media/mouseover.ae782429.mp3";